import { render, staticRenderFns } from "./wbItemDialog.vue?vue&type=template&id=62a9a540&scoped=true&"
import script from "./wbItemDialog.vue?vue&type=script&lang=js&"
export * from "./wbItemDialog.vue?vue&type=script&lang=js&"
import style0 from "./wbItemDialog.vue?vue&type=style&index=0&id=62a9a540&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a9a540",
  null
  
)

export default component.exports